import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const styles = (theme) => ({
  button: {
    borderRadius: 0,
    justifyContent: 'flex-end',
    padding: '12px 0px',
    width: 18,
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  checkbox: {
    color: theme.palette.primary.main,
    padding: '12px 0px',
    width: 28,
  },
  fade: {
    maxHeight: 384,
    overflowY: 'auto',
  },
  popper: {
    background: theme.palette.common.white,
    borderRadius: 3,
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px #E0E0E0',
    cursor: 'default',
    padding: theme.spacing.unit,
    zIndex: 100,
  },
  wrapper: {
    display: 'inline-block',
    height: 48,
    width: 48,
  },
});

class CheckboxDropDownMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      checked: props.checked,
      menuAnchor: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { checked } = this.props;

    if (checked !== nextProps.checked) this.setState({ checked: nextProps.checked });
  }

  handleChange = (event, checked) => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(event, checked);
    } else {
      this.setState({ checked });
    }
  };

  handleDropDownButtonClick = (event) => {
    const { menuAnchor } = this.state;

    if (!event || menuAnchor) {
      this.setState({ menuAnchor: null });
    } else if (!menuAnchor) {
      this.setState({ menuAnchor: event.currentTarget });
    }
  };

  render() {
    const { classes, children, disabled } = this.props;
    const { checked, menuAnchor } = this.state;

    return (
      <div className={classes.wrapper}>
        <Checkbox
          disabled={disabled}
          checked={checked}
          className={classes.checkbox}
          color="primary"
          disableRipple
          disableTouchRipple
          onChange={this.handleChange}
        />
        <IconButton
          className={classes.button}
          color="primary"
          disableRipple
          disableTouchRipple
          onClick={this.handleDropDownButtonClick}
        >
          <ArrowDropDownIcon />
          <Popper anchorEl={menuAnchor} className={classes.popper} disablePortal open={Boolean(menuAnchor)} transition>
            {({ TransitionProps }) => (
              <ClickAwayListener onClickAway={debounce(this.handleDropDownButtonClick, 100)}>
                <Fade className={classes.fade} timeout={100} {...TransitionProps}>
                  <Paper elevation={0}>
                    <MenuList disablePadding>{children}</MenuList>
                  </Paper>
                </Fade>
              </ClickAwayListener>
            )}
          </Popper>
        </IconButton>
      </div>
    );
  }
}

CheckboxDropDownMenu.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

CheckboxDropDownMenu.defaultProps = {
  checked: false,
};

export default withStyles(styles)(CheckboxDropDownMenu);
